export default __webpack_public_path__ + "static/media/company-logo.6ffcd9a5.svg";